<div class="row">
  <div class="col-12">
    <h3 class="title"><b>Versión</b></h3>
    Frontend {{ version_front }}
    <br />
    Backend
    {{ version_back }}
  </div>

  <div class="col-12">
    <h3 class="title"><b>Soporte</b></h3>
    Pagina web: <a [href]="web" target="_blank">{{ web }}</a>
    <br />
    Correo : {{ email }}
  </div>
</div>
